import { mapState } from 'vuex'
import camelCase from 'lodash/camelCase'

export default {
  props: {
    field: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapState({
      contentByField: 'content',
      helpRequested: 'helpRequested',
      fieldToShowRequestHelpPrompt: 'fieldToShowRequestHelpPrompt',
      requestHelpUrl: 'requestHelpUrl',
      validationErrorsByField: 'validationErrors',
      values: 'values'
    }),

    content() {
      return this.contentByField[this.field]
    },

    showRequestHelpPrompt() {
      return this.fieldToShowRequestHelpPrompt === this.field
    },

    validationErrors() {
      return this.validationErrorsByField[camelCase(this.field)]
    },

    value() {
      return this.values[this.field]
    }
  },

  methods: {
    scrollIntoView() {
      this.$refs.field.scrollIntoView()
    },

    updateFieldValue(newValue) {
      this.$store.commit('setValue', { field: this.field, value: newValue })
    }
  }
}
